import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import { Container, Grid, Tooltip, IconButton, TextField, Badge, Button ,Dialog} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import UserDropDownMenu from './UserDropDownMenu';
import WhatsNewCompleteList from './WhatsNewCompleteList';
import FAQsList from './FAQsList';
import * as actions from '../actions';
import ReportAnIssue from './ReportAnIssue';
import PageLoader from './PageLoader';
import { getLocalStorageInfo, eraseGlobalCookie,clearCookie, getLessorsList, checkApiStatus } from '../../utils';
import { globalGetService } from '../../utils/globalApiServices';
import { trackLogOut } from '../../utils/mixpanel'
import { getWhatsNewFeaturesListApi, getFaqsListApi, getHeaderCartCountApi } from '../apiServices';
import { lessorUpdateApi } from '../../application/auth/apiServices'
import commmverge from '../../assets/images/image003.jpg';
import config from '../../config';
import Cookies from 'universal-cookie'
import ApplicationsAccess from './ApplicationsAccess';
const cookies = new Cookies();
let localInfo  = getLocalStorageInfo()?.defaultLessor
class DesktopHeader extends Component {
  constructor(props){
    super(props);
    this.state = {
      pageLoader:false,
      formSubmitLoader:false,
      whtsNewModal:false,
      whtsNewList:[],
      faqsModal:false,
      faqsList:[],
      headerCount:{},
      appswictherModal:false,
      lessorList:[],
      lessor:{ id: localInfo?.id || '', name:  localInfo?.name || "" },
      oldLessor:{ id: localInfo?.id || '', name:  localInfo?.name || "" }
    }
    this.getWhatsNewFeaturesListApi = getWhatsNewFeaturesListApi.bind(this);
    this.getFaqsListApi = getFaqsListApi.bind(this);
    this.lessorUpdateApi = lessorUpdateApi.bind(this);
    this.getHeaderCartCountApi = getHeaderCartCountApi.bind(this);
  }
  
  componentDidMount(){
    this.getHeaderCartCountApi();
    globalGetService('/sso-lessor/list/')
    .then(response => {
      if(checkApiStatus(response)){
        let userInfo = getLocalStorageInfo();
        userInfo = {
          ...userInfo,
          lessor_list: response.data.data
        }
        this.setState({lessorList:response.data.data})
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
    })


  }
  logout = () => {
    localStorage.clear();
    clearCookie('lessorAccess', '.sparta.aero', '/')
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('userName')
    cookies.remove('lessorAccess' , {path: "/", domain: "sparta.aero"})
    this.props.history.push('/login')
    trackLogOut()
  }
 
  render(){
    const { whtsNewModal, whtsNewList, faqsModal, faqsList, headerCount, pageLoader, formSubmitLoader, lessorList, oldLessor } = this.state;;
    return(
      <Fragment>
        <header className="desktop-header">
          <Container maxWidth={false}  style={{padding:'0px 5px'}}>
            <Grid container  spacing={0} alignItems="center" justify="center">
              <Grid item xs={5}>
                <ul className="list-inline app-logo-search flex-centered">
                  <li className="list-inline-item app-logo">
                  <a href={config.domain.subDomian} target="_blank" rel="noopener noreferrer">
											<img src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/sparta_logo.png" alt="Sparta" />
										</a>
                  </li>
                  <li>
                    <Button
                      className="app-switcher"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() =>this.setState({appswictherModal:true})}
                      endIcon={<ArrowDropDownIcon />}
                    >
                      CommVerge
                    </Button>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={7}>
                <ul className="list-inline header-right-nav flex-centered">
                  <li className="list-inline-item">
                    <WhatsNewCompleteList />
                  </li>
                  <li className="list-inline-item">
                    <ReportAnIssue type="head"/>
                  </li>
                  <li className="list-inline-item">
                    <Tooltip title="FAQs" arrow>
                        <IconButton className="faq-icon" size="small" color="primary" onClick={() => this.getFaqsListApi(this.props)}>
                          <QuestionAnswerIcon color="primary" fontSize="small" />
                        </IconButton>
                    </Tooltip>
                  </li>
                  <li className="list-inline-item">
                    <Tooltip title="Notifications" arrow>
                      <IconButton size="small" color="primary">
                        <a href={`${config.domain.subDomian}notifications`} target="_blank">
                          <Badge max={99} badgeContent={headerCount.notification_count? headerCount.notification_count:0} color="secondary">
                            <NotificationsActiveIcon color="primary" fontSize="small" />
                          </Badge>
                        </a>
                      </IconButton>
                    </Tooltip>
                  </li>
                  { getLocalStorageInfo() ?
                    <li className="list-inline-item lessor-dropdown" style={{width:'215px'}}>
                      <Autocomplete
                        options = {lessorList}
                        clearOnBlur={false}
                        getOptionLabel={option => option.name}
                        disableClearable={true}
                        filterSelectedOptions={true}
                        value={this.state.lessor}
                        onOpen={()=>{
                          this.setState({lessor:null})
                        }}
                        onClose={(_, reason)=>{
                          if(reason !=='select-option'){
                            this.setState({lessor:oldLessor})
                          }
                        }}
                        onChange={(e, data) => this.lessorUpdateApi(this.props, {lessor_id:data.id})}
                        renderInput={params => <TextField placeholder={oldLessor?.name} variant='outlined' size='small' {...params} margin="none" fullWidth InputLabelProps={{shrink: true}} />}
                      />
                  </li>:null
                  }

                  <li className="list-inline-item user-dropdown">
                    <UserDropDownMenu
                      logout={this.logout}
                    />
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Container>
        </header>
        { faqsModal ?
            <FAQsList medialLink={this.state.medialLink} toggleModalFn={() => this.setState({faqsModal:false})} modal={faqsModal} faqsList={faqsList} />:null
          }
             { this.state.appswictherModal ?
            <Dialog
              open={this.state.appswictherModal}
              onClose={() => this.setState({appswictherModal:false})}
              aria-labelledby="scroll-dialog-title"
              fullScreen={true}
              className='application-swicther-modal'
            >
              <ApplicationsAccess
                handleClose={() => this.setState({appswictherModal:false})}
              />
            </Dialog>
            : null
        }
        { pageLoader || formSubmitLoader ? <PageLoader/>:null }
        <div style={{height:'45px'}}></div>
      </Fragment>
    )
  }
}
const mapStateToProps = state => ({
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // toggleTheAppSwitcher: (flag) => dispatch({type:actions.APPS_SWITCHER, payload:flag}),
  }
}
export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(DesktopHeader)))
